// Formateo de dinero (provisional; Cowre no calcula montos — solo los guarda/muestra).
// Locale es-CO (peso): separador de miles con punto. Sin asumir moneda concreta → prefijo "$".

const NF = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 2 });
const NF_INT = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

// Muestra un valor como "$ 12.500.000". null/'' → "—".
export function fmtMoney(value) {
    if (value == null || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    return `$ ${NF.format(n)}`;
}

// Solo dígitos (enteros de peso). '' si vacío. Para el input amigable.
export function digitsOnly(text) {
    return String(text ?? '').replace(/[^\d]/g, '');
}

// Formatea una cadena de dígitos con separador de miles para mostrar en el input.
export function groupThousands(digits) {
    if (digits === '' || digits == null) return '';
    return NF_INT.format(Number(digits));
}
